
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import WebsiteRepositoryInterface, { WebsiteCreation, WebsiteDeletion } from '@/services/Website/interfaces';
import { DataTableHeader } from 'vuetify';
import { WebsiteMigration } from '@/services/WebsiteMigrations/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'websiteRepository',
  ],
})
export default class Resources extends Vue {
  public loading = false;

  public websiteRepository!: WebsiteRepositoryInterface;

  public websiteId: number = 0;

  public creationHeaders: DataTableHeader[] = [
    { text: 'ID', value: 'id' },
    { text: 'Website ID', value: 'websiteId' },
    { text: 'Status', value: 'status' },
  ];

  public deletionHeaders: DataTableHeader[] = [
    { text: 'ID', value: 'id' },
    { text: 'Website ID', value: 'websiteId' },
    { text: 'Type', value: 'type' },
    { text: 'Status', value: 'status' },
  ];

  public migrationHeaders: DataTableHeader[] = [
    { text: 'ID', value: 'id' },
    { text: 'Source Website ID', value: 'sourceWebsiteId' },
    { text: 'Target Website ID', value: 'targetWebsiteId' },
    { text: 'Type', value: 'type' },
    { text: 'Status', value: 'status' },
  ];

  public resourceTypes: {
    CREATION: number
    DELETION: number
    MIGRATION: number
  } = {
    CREATION: 0,
    DELETION: 1,
    MIGRATION: 2,
  };

  public creations: WebsiteCreation[] = [];

  public deletions: WebsiteDeletion[] = [];

  public migrations: WebsiteMigration[] = [];

  public async created(): Promise<void> {

  }

  public async loadResources(): Promise<void> {
    try {
      this.loading = true;

      const resources = await this.websiteRepository.getWebsiteOrchestratorResources(this.websiteId);
      this.creations = resources.creations || [];
      this.deletions = resources.deletions || [];
      this.migrations = resources.migrations || [];

      this.loading = false;
    } catch (error) {
      this.$errorDialog.show('Failed to load website resources.');
    }
  }

  public async viewResource(resourceId: number, resourceType: number): Promise<void> {
    await this.$router.push({
      name: 'view_resource',
      params: {
        resourceId: resourceId.toString(),
        resourceType: resourceType.toString(),
        websiteId: this.websiteId.toString(),
      },
    });
  }

  public transformKebabCase(str: string): string {
    return str
      .replaceAll('-', ' ')
      .toUpperCase();
  }
}
